import { z } from 'zod/v4'

export const ParsedGeometryValidator = z.object({
        type: z.enum(['Polygon', 'MultiPolygon']),
        coordinates: z.any(),
})

export const CustomTargetingBoundaryValidator = z.object({
        id: z.string(),
        state: z.string(),
        type: z.string(),
        name: z.string(),
        metadata: z.record(z.string(), z.any()),
        geometry: ParsedGeometryValidator,
})

export const CountyValidator = CustomTargetingBoundaryValidator.extend({
        type: z.literal('county'),
})

export type LookupCounty = Pick<County, 'id' | 'state' | 'name'>

export const ZipCodeValidator = CustomTargetingBoundaryValidator.extend({
        type: z.literal('zipcode'),
})

export type CustomTargetingBoundary = z.infer<typeof CustomTargetingBoundaryValidator>
export type County = z.infer<typeof CountyValidator>
export type ZipCode = z.infer<typeof ZipCodeValidator>


export type LookupZipCode = Pick<ZipCode, 'id' | 'state' | 'name'>

export type ParsedGeometry = z.infer<typeof ParsedGeometryValidator>
